import React from "react";
import s from "./style.module.css";

export default function Presentation() {
  return (
    <div className={`${s.global} ${s.presentation} `}>
      <span className="text-nowrap">
        <span className={`${s.highlight}`}>Ingénieur freelance </span>
        dans l'informatique.
      </span>
      <br />
      Passionné par la création de solutions{" "}
      <span className={`${s.highlight}`}>robustes</span> et{" "}
      <span className={`${s.highlight}`}>évolutives</span>, j'interviens sur des
      missions <span className={s.noWrap}>variées : </span>
      <span className={`${s.highlight}`}>backend</span>,{" "}
      <span className={`${s.highlight}`}>frontend</span>,{" "}
      <span className={`${s.highlight}`}>base de données</span>,{" "}
      <span className={`${s.highlight}`}>intégration continue</span> (CI/CD).
      Curieux et avide d'apprendre, je suis toujours à l'écoute des{" "}
      <span className={`${s.highlight}`}>évolutions techniques</span> et des{" "}
      <span className={`${s.highlight}`}>bonnes pratiques</span> associées.
      Cette démarche me permet d’accompagner mes clients efficacement dans la{" "}
      <span className={`${s.highlight}`}>conception</span>, la{" "}
      <span className={`${s.highlight}`}>réalisation</span> et l’
      <span className={`${s.highlight}`}>intégration</span> de leurs projets
      numériques de bout en bout.
      <br />
      <br />
      <p>
        <span className={`${s.highlight}`}>Ma devise</span> : pas de problème,
        que des{" "}
        <span className={`${s.highlight}`}>
          <span className="text-nowrap">solutions !</span>
        </span>
      </p>
    </div>
  );
}
